import { render, staticRenderFns } from "./SignOfTheWeek.vue?vue&type=template&id=7a4c5cff"
import script from "./SignOfTheWeek.vue?vue&type=script&lang=ts"
export * from "./SignOfTheWeek.vue?vue&type=script&lang=ts"
import style0 from "./SignOfTheWeek.vue?vue&type=style&index=0&id=7a4c5cff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports